"use client";
import { playVideo, stopVideo, videoStorage } from "@/events";
import { useVideoVisibility } from "@/hooks";
import { useVideoRef } from "@/hooks/use-video-ref";
import { useIsMobile } from "@/store/device";
import classNames from "classnames";
import Image from "next/image";
import { MouseEventHandler, useEffect, useState } from "react";
import { isHeroBanner } from "../../events/hero-banner";
import { IGameVideo } from "./game-video.types";

export const GameVideo: IGameVideo = ({ url, poster, className, id, autoPlay, noMouseEvents }) => {
  const videoRef = useVideoRef();

  const [showPoster, setShowPoster] = useState(true);

  useVideoVisibility({ videoRef });

  const isMobile = useIsMobile();

  const onEnter: MouseEventHandler = () => {
    if (!videoRef.current) return;
    playVideo(videoRef.current);
  };

  const onLeave: MouseEventHandler = () => {
    if (!videoRef.current) return;
    stopVideo(videoRef.current);
  };

  useEffect(() => {
    const isHero = isHeroBanner(videoRef.current);

    if (isHero && videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.play().catch((error) => {
        console.log("Autoplay was prevented:", error);
        // You could add a play button overlay here as a fallback
      });
    }

    return videoStorage.delete();
  }, []);

  return (
    <div
      onMouseEnter={!isMobile && !noMouseEvents ? onEnter : undefined}
      onMouseLeave={!isMobile && !noMouseEvents ? onLeave : undefined}
      onClick={isMobile ? onEnter : undefined}
      className={classNames(
        "game-video w-full overflow-hidden relative h-[calc(100%-36px)] md:h-[calc(100%-50px)]",
        className
      )}
    >
      <video
        preload="auto"
        ref={videoRef}
        id={id}
        loop
        muted
        onPlay={() => setShowPoster(false)}
        onPause={() => setShowPoster(true)}
        autoPlay={autoPlay}
        controls={false}
        playsInline
        className={"w-full h-full object-cover"}
      >
        <source
          src={url}
          type="video/mp4"
        />
      </video>
      <div className="w-full h-full absolute top-0 left-0 overflow-hidden">
        {poster && (
          <Image
            src={poster}
            width={836}
            height={800}
            alt="poster"
            className={classNames(
              {
                "opacity-0": !showPoster,
                "opacity-100": showPoster,
              },
              "absolute top-0 left-0 w-[101%] h-[101%] object-cover z-1"
            )}
          />
        )}
      </div>
    </div>
  );
};
